import request from '@/utils/request'

//往来单位

//查询责任书列表
export function getDwzrs(data) {
    return request({
        method: 'post',
        url: "/yzdservice/enterprise/dwzrs/list",
        data: data
    })
}
//上传责任书
export function saveDwzrs(data) {
    return request({
        method: 'post',
        url: "/yzdservice/enterprise/dwzrs/save",
        data: data
    })
}
export function getDetail(id) {
    return request({
        method: 'get',
        url: "/yzdservice/enterprise/dwzrs/detail/"+id
    })
}
